import { useState } from 'react';
import { api } from '../../lib/api';
import { useApi } from '../../lib/hooks';
import { useI18n } from '../../lib/i18n';
import { AsyncButton, Checkbox, Field, Input, Loading } from '../../ui/components';
import { Centered } from '../../ui/layout';

export function SignPage({ token }: { token: string }) {
  const i18n = useI18n();
  const doc = useApi(() => api<{ title: string; html: string; gym: { name: string }; signerName: string; hash: string }>(`/v1/public/contracts/${encodeURIComponent(token)}`), [token]);
  const [name, setName] = useState('');
  const [agree, setAgree] = useState(false);
  const [done, setDone] = useState(false);
  if (doc.error) return <Centered><h1>{i18n.t('sign.invalid_title')}</h1><p className="muted">{i18n.t('sign.invalid_text')}</p></Centered>;
  if (!doc.data) return <Centered><Loading /></Centered>;
  if (done) return <Centered><div className="success-mark">✓</div><h1>{i18n.t('sign.done_title')}</h1><p>{i18n.t('sign.done_text')}</p></Centered>;
  const d = doc.data;
  const srcDoc = `<!doctype html><meta charset="utf-8"><style>body{font-family:Georgia,serif;line-height:1.55;color:#1c1917;padding:8px 16px}h1{font-size:22px}h2{font-size:16px}</style>${d.html}`;
  return (
    <div className="page narrow stack">
      <p className="muted">{d.gym.name}</p>
      <h1>{d.title}</h1>
      <iframe className="doc-frame" title={d.title} sandbox="" srcDoc={srcDoc} />
      <div className="card stack">
        <Field label={i18n.t('sign.type_name')} hint={i18n.t('sign.type_name_hint', { name: d.signerName })}>
          <Input value={name} autoComplete="name" onChange={(e) => setName(e.target.value)} />
        </Field>
        <Checkbox checked={agree} onChange={setAgree} label={i18n.t('sign.agree')} />
        <p className="small muted">{i18n.t('sign.legal_note', { hash: d.hash.slice(0, 16) })}</p>
        <AsyncButton size="lg" disabled={!agree || name.trim().length < 3} onClick={async () => {
          await api(`/v1/public/contracts/${encodeURIComponent(token)}/sign`, { body: { signerName: name, agree } });
          setDone(true);
        }}>{i18n.t('sign.sign')}</AsyncButton>
      </div>
    </div>
  );
}
